import {RestrictedRouteModuleConfiguration} from "../router/model/UserPermission";
import {
    ANGULAR_CIRCULAR_DATE_TILE_PICKER_MODULE_NAME,
    SchedulingModuleName,
    SchedulingServiceModuleName,
    UserServiceModuleName,
    WebSocketProviderModuleName
} from "../utils/names/optionalModuleNames";
import {AngularJsMaterialModuleName, LoaderModuleName} from "../utils/names/requiredModulesNames";
import {NavigationAccessRoles, NavigationItem} from "../main/model/navigationItem";
import {UserGranredAuthorityName} from "../router/const/AllPermitions";
import {QueuedTaskServiceName} from "../utils/names/serviceNames";
import {getTabName} from "modules/utils/TabNameUtils";

export const SchedulingModuleConfiguration = new RestrictedRouteModuleConfiguration(
    SchedulingModuleName,
    [
        SchedulingModuleName,
        LoaderModuleName,
        SchedulingServiceModuleName,
        LoaderModuleName,
        AngularJsMaterialModuleName,
        ANGULAR_CIRCULAR_DATE_TILE_PICKER_MODULE_NAME,
        WebSocketProviderModuleName,
        UserServiceModuleName
    ],
    [
        ["/scheduling", {
            template: require("./route/scheduling.html"),
            controller: 'schedulingController',
            resolve: {
                scheduledTasks: ['SchedulesService', function (SchdulesService) {
                    return SchdulesService.getSchedules().then(resp => {
                        //todo add error handling
                        return resp.data;
                    });
                }],
                tasksQueue: [QueuedTaskServiceName, function (QueuedTaskService) {
                    return QueuedTaskService.pullExecutionQueue()
                        .then(resp => {
                            return resp.data;
                        })
                }]
            }
        }]
    ],
    [
        new NavigationItem({
            title: "Scheduled Tasks",
            href: "#!scheduling",
            accessRole: [NavigationAccessRoles.ROLE_ADMIN],
            activeFunction: (routeName) => {
                return routeName.indexOf("scheduling") !== -1;
            }
        })
    ],
    [SchedulingModuleName, SchedulingServiceModuleName],
    [UserGranredAuthorityName.SCHEDULED_TASKS],
    getTabName() + '| Schedules'
);

export default SchedulingModuleConfiguration;